/* GBS COD — Ecomus v2.9.0
 * 1) Intercepta el add-to-cart (form submit, fetch /cart/add.js, theme.cart.*)
 *    y reemplaza el variant id del producto por el del "Anticipo" (mismo SKU).
 * 2) Añade line item properties visibles: Producto, Variante, Modalidad y
 *    Saldo a pagar al recibir.
 * 3) Después de cada mutación del carrito, reescribe la nota del pedido con
 *    el desglose de items COD y el total a pagar al recibir.
 * 4) Si el id original no aparece en el mapping, hace fallback por valores de
 *    opción seleccionados (ej. "S") para respetar la talla elegida.
 */
(function () {
  var DEFAULT_NOTE_TEMPLATE =
    'Este pedido incluye productos contra entrega. El cliente ya abonó el anticipo; el saldo se paga al recibir el pedido.\n\n{{items}}\n\nTotal a pagar al recibir: {{total_balance}}';

  function parseMap(raw) {
    if (!raw) return {};
    try { return JSON.parse(raw) || {}; } catch (_) { return {}; }
  }
  function parseList(raw) {
    if (!raw) return [];
    try { var v = JSON.parse(raw); return Array.isArray(v) ? v : []; } catch (_) { return []; }
  }
  function parseVariants(raw) {
    if (!raw) return [];
    try { var v = JSON.parse(raw); return Array.isArray(v) ? v : []; } catch (_) { return []; }
  }
  function norm(v) {
    return String(v == null ? '' : v).replace(/s+/g, ' ').trim().toLowerCase();
  }
  function cleanText(v) {
    return String(v == null ? '' : v).replace(/s+/g, ' ').trim();
  }
  function arrayContainsOption(arr, val) {
    var needle = norm(val);
    if (!needle) return false;
    for (var i = 0; i < arr.length; i++) {
      if (norm(arr[i]) === needle) return true;
    }
    return false;
  }
  function variantOptions(v) {
    return (v && Array.isArray(v.options)) ? v.options.map(cleanText).filter(Boolean) : [];
  }
  function readOriginalVariants(selector) {
    return selector.__gbsOriginalVariants || (selector.__gbsOriginalVariants = parseVariants(selector.getAttribute('data-original-variants')));
  }
  function readByOpts(selector) {
    return selector.__gbsByOpts || (selector.__gbsByOpts = parseList(selector.getAttribute('data-advance-variant-by-options')));
  }
  function readMap(selector) {
    return selector.__gbsMap || (selector.__gbsMap = parseMap(selector.getAttribute('data-advance-variant-map')));
  }
  function mapHasOriginalId(selector, id) {
    var map = readMap(selector);
    return id != null && map && !!map[String(id)];
  }
  function findOriginalVariantById(selector, id) {
    if (id == null) return null;
    var variants = readOriginalVariants(selector);
    var key = String(id);
    for (var i = 0; i < variants.length; i++) {
      if (variants[i] && String(variants[i].id) === key) return variants[i];
    }
    return null;
  }
  function allPicksInOptions(picks, opts) {
    if (!picks || !picks.length) return true;
    if (!opts || !opts.length) return false;
    for (var i = 0; i < picks.length; i++) {
      if (!arrayContainsOption(opts, picks[i])) return false;
    }
    return true;
  }
  function knownOptionIndex(selector, value) {
    var needle = norm(value);
    if (!needle) return -1;
    var found = {};
    readOriginalVariants(selector).forEach(function (v) {
      variantOptions(v).forEach(function (opt, idx) {
        if (norm(opt) === needle) found[idx] = 1;
      });
    });
    readByOpts(selector).forEach(function (entry) {
      ((entry && entry.options) || []).forEach(function (opt, idx) {
        if (norm(opt) === needle) found[idx] = 1;
      });
    });
    var keys = Object.keys(found);
    return keys.length === 1 ? parseInt(keys[0], 10) : -1;
  }
  function isKnownOptionValue(selector, value) {
    var variants = readOriginalVariants(selector);
    var byOpts = readByOpts(selector);
    if (!variants.length && !byOpts.length) return !!cleanText(value);
    for (var i = 0; i < variants.length; i++) {
      if (arrayContainsOption(variantOptions(variants[i]), value)) return true;
    }
    for (var j = 0; j < byOpts.length; j++) {
      if (arrayContainsOption((byOpts[j] && byOpts[j].options) || [], value)) return true;
    }
    return false;
  }
  function rememberOptionPick(selector, value, variantId) {
    if (!selector) return;
    var val = cleanText(value);
    if (val && isKnownOptionValue(selector, val)) {
      var idx = knownOptionIndex(selector, val);
      selector.__gbsPickedByIndex = selector.__gbsPickedByIndex || {};
      if (idx >= 0) selector.__gbsPickedByIndex[idx] = val;
      else selector.__gbsLastLoosePick = val;
    }
    if (variantId != null && mapHasOriginalId(selector, variantId)) {
      selector.__gbsCurrentOriginalId = String(variantId);
    }
  }
  function rememberedPicks(selector) {
    if (!selector) return [];
    var out = [];
    var byIndex = selector.__gbsPickedByIndex || {};
    Object.keys(byIndex).sort(function (a, b) { return parseInt(a, 10) - parseInt(b, 10); }).forEach(function (k) {
      if (byIndex[k]) out.push(byIndex[k]);
    });
    if (!out.length && selector.__gbsLastLoosePick) out.push(selector.__gbsLastLoosePick);
    return out;
  }
  function extractVariantId(el) {
    if (!el || !el.getAttribute) return null;
    return el.getAttribute('data-variant-id') ||
      el.getAttribute('data-variantid') ||
      el.getAttribute('data-variant') ||
      el.getAttribute('data-id') ||
      (el.dataset && (el.dataset.variantId || el.dataset.variantid || el.dataset.variant || el.dataset.id)) ||
      null;
  }
  function extractOptionValue(el) {
    if (!el) return '';
    if (el.matches && el.matches('input, select, textarea')) return cleanText(el.value);
    var input = el.querySelector && el.querySelector('input[type="radio"], input[type="checkbox"]');
    return cleanText(
      (el.getAttribute && (
        el.getAttribute('data-value') ||
        el.getAttribute('data-option-value') ||
        el.getAttribute('data-option') ||
        el.getAttribute('data-title') ||
        el.getAttribute('aria-label') ||
        el.getAttribute('title')
      )) ||
      (input && input.value) ||
      (el.textContent || '')
    );
  }
  function captureOptionInteraction(selector, event) {
    var target = event && event.target;
    if (!selector || !target || !target.closest) return;
    if (target.closest('.gbs-cod-selector')) return;
    var optionEl = target.closest(
      '[data-variant-id], [data-variantid], [data-variant], [data-option-value], [data-value], ' +
      '.tf-variant-picker__item, .variant-picker__option, .variant-picker__button, .variant-input, .variant-input__label, ' +
      '.swatch, .swatch-element, .swatch__label, .color-swatch, .size-swatch, select, input[type="radio"], label'
    );
    if (!optionEl) return;
    rememberOptionPick(selector, extractOptionValue(optionEl), extractVariantId(optionEl));
    setTimeout(function () {
      readSelectedOptionValues(selector).forEach(function (p) { rememberOptionPick(selector, p, null); });
      var current = readCurrentVariantId(selector);
      if (current) rememberOptionPick(selector, '', current);
    }, 0);
  }
  function captureVariantEvent(selector, event) {
    var d = event && event.detail;
    var v = d && (d.variant || d.currentVariant || d.selectedVariant);
    if (v && v.id) {
      rememberOptionPick(selector, '', v.id);
      if (Array.isArray(v.options)) v.options.forEach(function (opt) { rememberOptionPick(selector, opt, null); });
    }
  }
  function optionScopes(selector) {
    // El variant-picker de Ecomus suele estar FUERA del <form action="/cart/add">
    // (vive dentro del <product-info> como sibling del form). Buscamos radios/
    // selects/botones activos en el form + el contenedor product-info completo
    // para no depender de que Ecomus haya actualizado el hidden [name="id"].
    var scopes = [];
    if (selector && selector.__gbsForm) scopes.push(selector.__gbsForm);
    if (selector) {
      var pi = selector.closest('product-info, .tf-main-product, main-product, .product, .product-single, section');
      if (pi && scopes.indexOf(pi) === -1) scopes.push(pi);
    }
    if (!scopes.length) scopes.push(document);
    return scopes;
  }
  function readSelectedOptionValues(selector) {
    var scopes = optionScopes(selector);
    var seen = {};
    var vals = [];
    function pushVal(v) {
      var s = cleanText(v);
      if (!s || seen[s]) return;
      seen[s] = 1;
      vals.push(s);
    }
    scopes.forEach(function (root) {
      // Fuente principal: swatches/botones visibles activos. Evitamos hidden inputs
      // porque algunos themes los dejan stale en la variante por defecto (M).
      root.querySelectorAll(
        '.tf-variant-picker__item.active, .tf-variant-picker__item.is-active, .tf-variant-picker__item.is-selected, .tf-variant-picker__item.selected, .tf-variant-picker__item.current, ' +
        '.tf-variant-picker__item[aria-checked="true"], .tf-variant-picker__item[aria-pressed="true"], .tf-variant-picker__item[data-selected="true"], ' +
        '[data-option-value].active, [data-option-value].is-active, [data-option-value].is-selected, [data-option-value].selected, [data-option-value][aria-checked="true"], [data-option-value][aria-pressed="true"], [data-option-value][data-selected="true"], ' +
        '.color-swatch.active, .color-swatch.is-selected, .color-swatch.selected, .size-swatch.active, .size-swatch.is-selected, .size-swatch.selected, .variant-input.active, .variant-input.is-selected, .variant-input.selected, .swatch.active, .swatch.is-selected, .swatch.selected, .swatch__input:checked + label, input[type="radio"]:checked + label, ' +
        '[data-value].active, [data-value].is-active, [data-value].is-selected, [data-value].selected, [data-value][aria-checked="true"], [data-value][aria-pressed="true"], [data-value][data-selected="true"]'
      ).forEach(function (el) {
        var v =
          el.getAttribute('data-value') ||
          el.getAttribute('data-option-value') ||
          el.getAttribute('data-option') ||
          (el.querySelector && el.querySelector('input') && el.querySelector('input').value) ||
          (el.textContent || '').trim();
        if (v && isKnownOptionValue(selector, v)) pushVal(v);
      });
      // Inputs reales visibles/controlados de Shopify. Hidden queda como último fallback.
      root.querySelectorAll('input[type="radio"]:checked, select').forEach(function (el) {
        var name = (el.getAttribute('data-option-name') || el.name || '');
        if (el.value && (/^options\[/.test(name) || el.closest('.tf-variant-picker, .variant-picker, variant-radios, variant-selects')) && isKnownOptionValue(selector, el.value)) pushVal(el.value);
      });
    });
    if (!vals.length) {
      rememberedPicks(selector).forEach(pushVal);
    }
    if (!vals.length) {
      scopes.forEach(function (root) {
        root.querySelectorAll('input[type="hidden"][name^="options["]').forEach(function (el) {
          if (el.value && isKnownOptionValue(selector, el.value)) pushVal(el.value);
        });
      });
    }
    return vals;
  }
  function findOriginalVariantByOptions(selector, picks) {
    var variants = readOriginalVariants(selector);
    if (!variants.length || !picks || !picks.length) return null;
    var candidates = [];
    for (var i = 0; i < variants.length; i++) {
      var opts = variantOptions(variants[i]);
      if (!opts.length) continue;
      var allOptsSelected = true;
      for (var j = 0; j < opts.length; j++) {
        if (!arrayContainsOption(picks, opts[j])) { allOptsSelected = false; break; }
      }
      if (allOptsSelected) candidates.push(variants[i]);
    }
    if (candidates.length === 1) return candidates[0];
    return null;
  }
  function hasRealOriginalVariants(selector) {
    var variants = readOriginalVariants(selector);
    if (!variants.length) return false;
    for (var i = 0; i < variants.length; i++) {
      var opts = variantOptions(variants[i]);
      if (opts.length && !(opts.length === 1 && norm(opts[0]) === 'default title')) return true;
    }
    return false;
  }
  function readCurrentVariantId(selector) {
    if (selector && selector.__gbsCurrentOriginalId) return String(selector.__gbsCurrentOriginalId);
    // 1) Custom element product-info expone currentVariant (Ecomus lo actualiza al elegir talla/color).
    var pi = selector && selector.closest('product-info, main-product, .tf-main-product');
    if (pi && pi.currentVariant && pi.currentVariant.id) return String(pi.currentVariant.id);
    if (pi && pi.dataset) {
      var dsVid = pi.dataset.currentVariantId || pi.dataset.variantId || pi.dataset.selectedVariantId;
      if (dsVid) return String(dsVid);
    }
    // 2) URL ?variant= (también actualizada por Ecomus tras cada cambio).
    try {
      var u = new URL(window.location.href);
      var vp = u.searchParams.get('variant');
      if (vp) return vp;
    } catch (_) {}
    // 3) Hidden [name="id"] del form (puede estar desactualizado en algunos themes).
    var form = selector && selector.__gbsForm;
    var idInput = form && form.querySelector('[name="id"]');
    return idInput ? idInput.value : null;
  }
  function resolveCodVariant(selector, origId) {
    if (!selector) return { ok: false, reason: 'missing_selector' };
    var map = readMap(selector);
    var picks = readSelectedOptionValues(selector);
    var hasRealVariants = hasRealOriginalVariants(selector);
    var rememberedVariantId = selector.__gbsCurrentOriginalId || null;

    // Prioridad absoluta: selección visible → variante original exacta → anticipo.
    if (picks.length) {
      var originalVariant = findOriginalVariantByOptions(selector, picks);
      if (originalVariant && originalVariant.id && map && map[String(originalVariant.id)]) {
        return {
          ok: true,
          id: String(map[String(originalVariant.id)]),
          originalId: String(originalVariant.id),
          picks: picks,
          options: variantOptions(originalVariant),
          source: 'visible_options'
        };
      }

      if (rememberedVariantId && map && map[String(rememberedVariantId)]) {
        var rememberedVariant = findOriginalVariantById(selector, rememberedVariantId);
        var rememberedOpts = rememberedVariant ? variantOptions(rememberedVariant) : [];
        if ((!readOriginalVariants(selector).length && !rememberedOpts.length) || (rememberedVariant && allPicksInOptions(picks, rememberedOpts))) {
          return {
            ok: true,
            id: String(map[String(rememberedVariantId)]),
            originalId: String(rememberedVariantId),
            picks: picks,
            options: rememberedOpts.length ? rememberedOpts : picks,
            source: 'captured_variant'
          };
        }
      }

      // Compatibilidad si el theme aún no copió data-original-variants.
      if (!readOriginalVariants(selector).length) {
        var byOpts = readByOpts(selector);
        var matches = [];
        for (var i = 0; i < byOpts.length; i++) {
          var entry = byOpts[i];
          var opts = (entry && entry.options) || [];
          if (!opts.length || !entry.id) continue;
          var allMatch = true;
          for (var j = 0; j < opts.length; j++) {
            if (!arrayContainsOption(picks, opts[j])) { allMatch = false; break; }
          }
          if (allMatch) matches.push(entry);
        }
        if (matches.length === 1) {
          return { ok: true, id: String(matches[0].id), picks: picks, options: matches[0].options || [], source: 'by_options_legacy' };
        }
      }

      return { ok: false, reason: 'no_exact_variant_for_visible_options', picks: picks };
    }

    // Fallback seguro: currentVariant solo si no hay una selección visible contradictoria.
    var current = readCurrentVariantId(selector);
    if (current && map && map[String(current)]) {
      var currentVariant = findOriginalVariantById(selector, current);
      if (readOriginalVariants(selector).length && !currentVariant) {
        return { ok: false, reason: 'current_variant_not_in_metadata', picks: picks, originalId: String(current) };
      }
      return { ok: true, id: String(map[String(current)]), originalId: String(current), picks: picks, options: currentVariant ? variantOptions(currentVariant) : [], source: 'current_variant' };
    }

    // No usar origId/default para productos con variantes reales: eso es lo que cae en M.
    if (origId != null && map && map[String(origId)] && !hasRealVariants) {
      return { ok: true, id: String(map[String(origId)]), originalId: String(origId), picks: picks, source: 'request_id_no_real_variants' };
    }

    if (!hasRealVariants) {
      var def = selector.getAttribute('data-advance-default-variant-id') || selector.getAttribute('data-advance-variant-id');
      if (def) return { ok: true, id: def, picks: picks, source: 'default_no_real_variants' };
    }

    return { ok: false, reason: 'unresolved', picks: picks };
  }
  function resolveAdv(selector, origId) {
    var resolution = resolveCodVariant(selector, origId);
    return resolution.ok ? resolution.id : null;
  }

  function findByOptsEntry(selector, advId) {
    var byOpts = readByOpts(selector);
    if (!byOpts || !byOpts.length || advId == null) return null;
    var key = String(advId);
    for (var i = 0; i < byOpts.length; i++) {
      if (byOpts[i] && String(byOpts[i].id) === key) return byOpts[i];
    }
    return null;
  }
  function validateResolvedVariant(selector, resolution) {
    // Verifica que las opciones (talla/color) de la variante de anticipo resuelta
    // contengan TODAS las opciones actualmente seleccionadas en el picker visible.
    // Si no hay picks visibles o no hay metadata de opciones, no bloqueamos.
    if (!resolution || !resolution.ok || !resolution.id) return { ok: false, reason: (resolution && resolution.reason) || 'unresolved', picks: resolution && resolution.picks };
    var picks = resolution.picks || readSelectedOptionValues(selector);
    if (!picks.length) return { ok: true };
    var entry = findByOptsEntry(selector, resolution.id);
    var expected = entry && entry.options;
    if (!expected || !expected.length) expected = resolution.options;
    if (!expected || !expected.length) return { ok: true };
    var missing = [];
    for (var j = 0; j < expected.length; j++) {
      if (!arrayContainsOption(picks, expected[j])) {
        missing.push(expected[j]);
      }
    }
    if (missing.length) return { ok: false, missing: missing, picks: picks, expected: expected, advId: resolution.id };
    return { ok: true };
  }
  function blockCodAdd(detail) {
    try { console.warn('[gbs-cod] Bloqueado: no se pudo resolver una variante COD segura.', detail); } catch (_) {}
    try {
      var picks = (detail && detail.picks && detail.picks.length) ? detail.picks.join(', ') : 'la talla/opción seleccionada';
      window.alert(
        'No se pudo confirmar la variante de contra entrega para ' + picks + '. ' +
        'Actualiza la página y vuelve a seleccionar la talla, o elige "Pagar completo".'
      );
    } catch (_) {}
  }




  function readSelectedOption(form, selector, resolution) {
    var opts = resolution && resolution.options;
    if (opts && opts.length) return opts.join(' / ');
    if (selector) {
      var picks = readSelectedOptionValues(selector);
      if (picks.length) return picks.join(' / ');
    }
    if (!form) return '';
    // Lee la opción visible del variant picker (ej. "Talla: M").
    var labels = form.querySelectorAll('.tf-variant-picker__label, .variant__label, .product-form__label');
    var parts = [];
    labels.forEach(function (lb) {
      var text = (lb.textContent || '').replace(/\s+/g, ' ').trim();
      if (text) parts.push(text);
    });
    if (parts.length) return parts.join(' · ');
    // Fallback: leer inputs de tipo radio/select checked del form.
    var picks = [];
    form.querySelectorAll('input[type="radio"]:checked, select').forEach(function (el) {
      var name = (el.getAttribute('data-option-name') || el.name || '').replace('options[', '').replace(']', '');
      var val = el.value || '';
      if (val && name && name !== 'id') picks.push(name + ': ' + val);
    });
    return picks.join(' · ');
  }
  function formatMoney(amount, currency) {
    try {
      return new Intl.NumberFormat('es-CO', { style: 'currency', currency: currency || 'COP', maximumFractionDigits: 0 }).format(amount);
    } catch (_) {
      return '$' + Math.round(amount).toLocaleString('es-CO');
    }
  }
  function buildProperties(selector, form, resolution) {
    var props = {};
    var mode = selector.getAttribute('data-lp-mode') || 'Modalidad';
    var modeValue = selector.getAttribute('data-lp-mode-value') || 'Contra entrega';
    var prodLbl = selector.getAttribute('data-lp-product') || 'Producto';
    var optLbl = selector.getAttribute('data-lp-option') || 'Variante';
    var balLbl = selector.getAttribute('data-lp-balance') || 'Saldo a pagar al recibir';
    var currency = selector.getAttribute('data-currency') || 'COP';
    var origPrice = parseFloat(selector.getAttribute('data-original-price') || '0');
    var advance = parseFloat(selector.getAttribute('data-advance-amount') || '0');
    var balance = Math.max(0, origPrice - advance);
    var title = selector.getAttribute('data-original-title') || '';
    var option = readSelectedOption(form, selector, resolution);
    props[mode] = modeValue;
    if (title) props[prodLbl] = title;
    if (option) props[optLbl] = option;
    props[balLbl] = formatMoney(balance, currency);
    // Marca oculta usada al regenerar la nota (empieza con _ → no visible al cliente).
    props['_gbs_cod'] = '1';
    props['_gbs_cod_balance'] = String(balance);
    props['_gbs_cod_currency'] = currency;
    return props;
  }

  function bind(selector) {
    if (selector.dataset.gbsBound === '1') return;
    selector.dataset.gbsBound = '1';

    var defaultAdv = selector.getAttribute('data-advance-default-variant-id')
      || selector.getAttribute('data-advance-variant-id');
    if (!defaultAdv) return;

    var productInfo = selector.closest('product-info, .tf-main-product, main-product');
    var form =
      (productInfo && productInfo.querySelector('form[action*="/cart/add"]')) ||
      selector.closest('form[action*="/cart/add"]') ||
      document.querySelector('form[action*="/cart/add"]');
    selector.__gbsForm = form || null;

    function setMode(mode) { selector.dataset.gbsMode = mode; }
    function applySelection() {
      var checked = selector.querySelector('input[name="gbs_cod_type"]:checked');
      var isCod = checked && checked.value === 'cod';
      selector.querySelectorAll('.gbs-cod-option').forEach(function (opt) {
        opt.classList.remove('is-selected');
      });
      if (checked) checked.closest('.gbs-cod-option').classList.add('is-selected');
      setMode(isCod ? 'cod' : 'full');
    }

    selector.querySelectorAll('input[name="gbs_cod_type"]').forEach(function (r) {
      r.addEventListener('change', applySelection);
    });
    applySelection();

    var pickerScope = productInfo || selector.closest('.product, .product-single, section') || document;
    ['click', 'change', 'input'].forEach(function (evtName) {
      pickerScope.addEventListener(evtName, function (evt) { captureOptionInteraction(selector, evt); }, true);
    });
    ['variant:change', 'variantChange', 'shopify:variant:change', 'theme:variant:change'].forEach(function (evtName) {
      pickerScope.addEventListener(evtName, function (evt) { captureVariantEvent(selector, evt); }, true);
    });

    // (1) Submit del product-form de Ecomus.
    if (form) {
      form.addEventListener('submit', function (e) {
        if (selector.dataset.gbsMode !== 'cod') return;
        var idInput = form.querySelector('[name="id"]');
        if (!idInput) return;
        var original = idInput.value;
        var resolution = resolveCodVariant(selector, original);
        // Validación: la variante de anticipo resuelta DEBE cubrir las opciones
        // seleccionadas en el picker visible (evita agregar una talla distinta
        // a la que el cliente seleccionó, p. ej. cuando el hidden [name="id"]
        // del form llega desactualizado).
        var check = validateResolvedVariant(selector, resolution);
        if (!check.ok) {
          try { e.preventDefault(); e.stopImmediatePropagation(); } catch (_) {}
          blockCodAdd(check);
          return false;
        }
        idInput.value = resolution.id;
        // Inyecta properties temporales.
        var props = buildProperties(selector, form, resolution);
        var tempInputs = [];
        Object.keys(props).forEach(function (k) {
          var inp = document.createElement('input');
          inp.type = 'hidden';
          inp.name = 'properties[' + k + ']';
          inp.value = props[k];
          inp.dataset.gbsTemp = '1';
          form.appendChild(inp);
          tempInputs.push(inp);
        });
        setTimeout(function () {
          idInput.value = original;
          tempInputs.forEach(function (i) { i.remove(); });
          scheduleNoteUpdate();
        }, 0);
      }, true);
    }

  }

  function init() {
    document.querySelectorAll('.gbs-cod-selector').forEach(bind);
  }

  function currentCodSelector() {
    return document.querySelector('.gbs-cod-selector[data-gbs-mode="cod"]');
  }

  function mergeProperties(existing, extra) {
    var out = existing && typeof existing === 'object' ? Object.assign({}, existing) : {};
    Object.keys(extra).forEach(function (k) { out[k] = extra[k]; });
    return out;
  }
  function gbsBlockedError(detail) {
    var err = new Error('GBS COD: variante no resuelta de forma segura');
    err.__gbsCodBlocked = true;
    err.detail = detail;
    return err;
  }
  function resolveOrBlock(selector, origId) {
    var resolution = resolveCodVariant(selector, origId);
    var check = validateResolvedVariant(selector, resolution);
    if (!check.ok) {
      blockCodAdd(check);
      throw gbsBlockedError(check);
    }
    return resolution;
  }

  // (2) Patch global a fetch — cubre cart-drawer, quick-add, /cart/add y hooks post-carrito.
  if (!window.__gbsCodFetchPatched) {
    window.__gbsCodFetchPatched = true;
    var origFetch = window.fetch;
    window.fetch = function (input, init) {
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        var isCartAdd = url && url.indexOf('/cart/add') !== -1;
        var isCartMutation = url && (
          url.indexOf('/cart/change') !== -1 ||
          url.indexOf('/cart/update') !== -1 ||
          url.indexOf('/cart/clear') !== -1
        );
        var anyCod = currentCodSelector();
        if (isCartAdd && anyCod && init && init.body) {
          if (typeof init.body === 'string') {
            if (init.body.trim().charAt(0) === '{') {
              try {
                var obj = JSON.parse(init.body);
                if (obj && obj.id != null) {
                  var resolved = resolveOrBlock(anyCod, obj.id);
                  var props = buildProperties(anyCod, anyCod.__gbsForm, resolved);
                  obj.id = resolved.id;
                  obj.properties = mergeProperties(obj.properties, props);
                }
                if (obj && Array.isArray(obj.items)) {
                  obj.items = obj.items.map(function (it) {
                    var resolved2 = resolveOrBlock(anyCod, it && it.id);
                    var props2 = buildProperties(anyCod, anyCod.__gbsForm, resolved2);
                    var merged = Object.assign({}, it, { id: resolved2.id });
                    merged.properties = mergeProperties(merged.properties, props2);
                    return merged;
                  });
                }
                init.body = JSON.stringify(obj);
              } catch (err) { if (err && err.__gbsCodBlocked) return Promise.reject(err); }
            } else {
              var urlResolution = null;
              init.body = init.body.replace(
                /(^|&)id=([^&]*)/,
                function (_m, pfx, val) {
                  urlResolution = resolveOrBlock(anyCod, decodeURIComponent(val));
                  return pfx + 'id=' + encodeURIComponent(urlResolution.id);
                }
              );
              if (!urlResolution) urlResolution = resolveOrBlock(anyCod, null);
              var urlProps = buildProperties(anyCod, anyCod.__gbsForm, urlResolution);
              // Añade properties como pares urlencoded.
              Object.keys(urlProps).forEach(function (k) {
                init.body += '&' + encodeURIComponent('properties[' + k + ']') + '=' + encodeURIComponent(urlProps[k]);
              });
            }
          } else if (init.body instanceof FormData) {
            var cur = init.body.get('id');
            var resolved3 = resolveOrBlock(anyCod, cur);
            var props3 = buildProperties(anyCod, anyCod.__gbsForm, resolved3);
            init.body.set('id', resolved3.id);
            Object.keys(props3).forEach(function (k) {
              init.body.set('properties[' + k + ']', props3[k]);
            });
          }
        }
        var res = origFetch.apply(this, arguments);
        if (isCartAdd || isCartMutation) {
          res.then(scheduleNoteUpdate).catch(function () {});
        }
        return res;
      } catch (err) {
        if (err && err.__gbsCodBlocked) return Promise.reject(err);
        return origFetch.apply(this, arguments);
      }
    };
  }

  // (3) Patch a window.theme.cart si Ecomus lo expone.
  function patchThemeCart() {
    var t = window.theme && window.theme.cart;
    if (!t || t.__gbsPatched) return;
    t.__gbsPatched = true;
    ['addFromForm', 'addItem', 'addItemFromVariantId'].forEach(function (m) {
      if (typeof t[m] !== 'function') return;
      var orig = t[m].bind(t);
      t[m] = function () {
        var anyCod = currentCodSelector();
        if (anyCod && arguments.length) {
          var a0 = arguments[0];
          if (a0 instanceof FormData) {
            var resolved = resolveOrBlock(anyCod, a0.get('id'));
            var props = buildProperties(anyCod, anyCod.__gbsForm, resolved);
            a0.set('id', resolved.id);
            Object.keys(props).forEach(function (k) { a0.set('properties[' + k + ']', props[k]); });
          } else if (typeof a0 === 'object' && a0 !== null) {
            if ('id' in a0) {
              var resolved2 = resolveOrBlock(anyCod, a0.id);
              var props2 = buildProperties(anyCod, anyCod.__gbsForm, resolved2);
              a0.id = resolved2.id;
              a0.properties = mergeProperties(a0.properties, props2);
            } else {
              var propsNoId = buildProperties(anyCod, anyCod.__gbsForm, null);
              a0.properties = mergeProperties(a0.properties, propsNoId);
            }
          } else if (typeof a0 === 'string' || typeof a0 === 'number') {
            var resolved3 = resolveOrBlock(anyCod, a0);
            arguments[0] = resolved3.id;
          }
        }
        var out = orig.apply(this, arguments);
        Promise.resolve(out).then(scheduleNoteUpdate).catch(function () {});
        return out;
      };
    });
  }

  // (4) Regenerar la nota del pedido tras cada mutación del carrito.
  var noteTimer = null;
  function scheduleNoteUpdate() {
    if (noteTimer) clearTimeout(noteTimer);
    noteTimer = setTimeout(refreshCartNote, 250);
  }

  function anyRuleAttr(name) {
    var el = document.querySelector('.gbs-cod-selector[' + name + ']');
    return el ? el.getAttribute(name) : null;
  }

  function refreshCartNote() {
    fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || !Array.isArray(cart.items)) return;
        var codItems = cart.items.filter(function (it) {
          var p = it && it.properties;
          return p && (p._gbs_cod === '1' || p._gbs_cod === 1);
        });
        var currentNote = cart.note || '';
        var marker = '<!-- gbs-cod-note -->';
        var stripped = currentNote.split(marker)[0].trim();
        var newNote = stripped;
        if (codItems.length) {
          var prodLbl = anyRuleAttr('data-lp-product') || 'Producto';
          var optLbl = anyRuleAttr('data-lp-option') || 'Variante';
          var balLbl = anyRuleAttr('data-lp-balance') || 'Saldo a pagar al recibir';
          var currency = (codItems[0].properties && codItems[0].properties._gbs_cod_currency) || 'COP';
          var totalBalance = 0;
          var totalAdvance = 0;
          var lines = codItems.map(function (it) {
            var p = it.properties || {};
            var bal = parseFloat(p._gbs_cod_balance || '0') * (it.quantity || 1);
            var adv = ((it.final_price != null ? it.final_price : it.price) || 0) / 100 * (it.quantity || 1);
            totalBalance += bal;
            totalAdvance += adv;
            var name = p[prodLbl] || it.product_title || '';
            var opt = p[optLbl] || (it.variant_title || '');
            var qty = it.quantity && it.quantity > 1 ? ' x' + it.quantity : '';
            return '- ' + name + (opt ? ' (' + opt + ')' : '') + qty + ': anticipo ' + formatMoney(adv, currency) + ' · ' + balLbl + ' ' + formatMoney(bal, currency);
          });
          var tpl = anyRuleAttr('data-note-template') || DEFAULT_NOTE_TEMPLATE;
          if (!tpl) tpl = DEFAULT_NOTE_TEMPLATE;
          var body = tpl
            .replace('{{items}}', lines.join('\n'))
            .replace('{{total_balance}}', formatMoney(totalBalance, currency))
            .replace('{{advance_total}}', formatMoney(totalAdvance, currency));
          newNote = (stripped ? stripped + '\n\n' : '') + marker + '\n' + body;
        }
        if (newNote !== currentNote) {
          fetch('/cart/update.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ note: newNote }),
          }).catch(function () {});
        }
      }).catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); patchThemeCart(); scheduleNoteUpdate(); });
  } else {
    init(); patchThemeCart(); scheduleNoteUpdate();
  }
  document.addEventListener('shopify:section:load', function () { init(); patchThemeCart(); });
  document.addEventListener('on:cart:refresh', function () { init(); scheduleNoteUpdate(); });
})();